var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Plan Checklist") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plan-Checklist",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list-quill",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25,23.259 L2.25,23.259 C1.42157288,23.259 0.75,22.5874271 0.75,21.759 L0.75,2.259 C0.75,1.43057288 1.42157288,0.759 2.25,0.759 L12.879,0.759 C13.2765472,0.759 13.6578016,0.916981752 13.939,1.198 L19.811,7.069 C20.0922632,7.35044347 20.25,7.73210629 20.25,8.13 L20.25,8.259",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75,0.759 L12.75,6.759 C12.75,7.58742712 13.4215729,8.259 14.25,8.259 L20.25,8.259",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.169,9.617 L6.037,12.459 C5.90649596,12.6327777 5.70702983,12.741403 5.49024781,12.7567504 C5.2734658,12.7720978 5.06068534,12.6926581 4.907,12.539 L3.75,11.382",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.169,16.367 L6.037,19.209 C5.90649596,19.3827777 5.70702983,19.491403 5.49024781,19.5067504 C5.2734658,19.5220978 5.06068534,19.4426581 4.907,19.289 L3.75,18.132",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.981,
    y1: 23.259,
    x2: 16.815,
    y2: 17.425,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.179,11.061 C22.4341737,10.9804077 21.6828263,10.9804077 20.938,11.061 L18.938,14.241 L17.709,11.952 C13.25,14.14 11.509,19.43 13.158,21.081 C15.37,23.3 24.128,19.416 23.179,11.061 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlans);
export default __webpack_public_path__ + "static/media/Plans.e01dec1cbb4f41ce2f0cb581c400e1a7.svg";
export { ForwardRef as ReactComponent };